import UserIcon from "@ch/assets/icons/pack/UserIcon";
import type { FC, ImgHTMLAttributes } from "react";
import type { BaseButtonProps } from "../Buttons/BaseButton";
import { avatarStatus, equalSizes, iconSizes } from "./variants";

export interface AvatarProps {
  className?: string;
  size?: BaseButtonProps["size"] | "xl";
  imageUrl?: string;
  defaultImageUrl?: string;
  status?: "none" | "active" | "in-active" | "disabled" | "deceased";
  imageProps?: Omit<ImgHTMLAttributes<HTMLImageElement>, "src">;
}

const Avatar: FC<AvatarProps> = ({
  className,
  imageUrl,
  defaultImageUrl,
  imageProps,
  status = "none",
  size = "base",
}) => {
  const sizeClassName = equalSizes[size];

  const iconSize = iconSizes[size];

  const imageUrlToUse = imageUrl ?? defaultImageUrl;

  const showStatus = status !== "none";

  const statusClassName = avatarStatus[status];

  return (
    <div
      className={`relative flex items-center justify-center rounded-full bg-gray-700 ring ring-gray-200 ${sizeClassName} ${className}`}
    >
      {imageUrlToUse ? (
        <img
          alt="avatar"
          className="h-full w-full rounded-full object-cover"
          src={imageUrlToUse}
          {...imageProps}
        />
      ) : (
        <UserIcon color="white" height={iconSize} width={iconSize} />
      )}
      {showStatus && (
        <div
          className={`absolute bottom-0.5 right-0.5 h-2 w-2 rounded-full ring-2 ring-white ${statusClassName}`}
        />
      )}
    </div>
  );
};

export default Avatar;
